import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";
import Select from "react-select";
import moment from "moment";
import { useParams, Link, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import ReportDate from "../../../components/Reports/ReportDate";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import { Box } from "@mui/material";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const CustomerBalanceSummary = (props) => {
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    ReportViewPermission,
    currencySymbolLocation,
  } = useContext(AppContext);
  const navigate = useNavigate();
  const locationid = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(1);
  const [agingMethod, setAgingMethod] = useState("Current");
  // const [selectReport, setSelectReport] = useState(7);

  const [classicView, setClassicView] = useState(true);

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);

    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const apicall = () => {
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/customerbalancesummary?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&filtertext=&startdate=${startdate}&enddate=${enddate}&locationid=${locationid}&agingmethod=${agingMethod}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )

      .then((res) => {
        // if (res.data.ResponseCode === "SUCCESS") {

        //   console.log(res.data.ResponseData, "check this response data");
        //   const FilterData = res.data.ResponseData?.map((el) => ({
        //     ...el,
        //     Balance: Number(el?.Balance),
        //     CustomerName: String(el?.CustomerName ?? ""),
        //   }));
        //   console.log(FilterData, "FilterData789");
        //   setResponseData(FilterData);
        //   setTotalSum(
        //     FilterData.reduce(
        //       (sum, item) => sum + (parseFloat(item.Balance) || 0),
        //       0
        //     )
        //   );
        // }

        if (res.data.ResponseCode === "SUCCESS") {
          console.log(res.data.ResponseData, "check this response data");

          const rawData = res.data.ResponseData ?? [];

          // Step 1: Map raw data into dictionary for fast lookup
          const customerMap = {};
          rawData.forEach((el) => {
            customerMap[el.Customerid] = {
              ...el,
              Balance: Number(el?.Balance),
              CustomerName: String(el?.CustomerName ?? ""),
              children: [],
            };
          });

          // Step 2: Create parent-child structure
          const rootCustomers = [];
          rawData.forEach((el) => {
            const current = customerMap[el.Customerid];
            if (el.ParentCustomerId === 0) {
              rootCustomers.push(current); // Parent
            } else if (customerMap[el.ParentCustomerId]) {
              // Remove children from the object before pushing to parent
              const { children, ...childWithoutChildren } = current;
              customerMap[el.ParentCustomerId].children.push(
                childWithoutChildren
              );
            }
          });

          // Step 3: Flatten tree structure (only include parents, their children will be shown via Tabulator's dataTree)
          const FilterData = rootCustomers; // Just use the root customers, Tabulator will handle hierarchy

          setResponseData(rootCustomers); // Pass the hierarchical data directly

          // Calculate total sum including all children
          const calculateTotal = (customers) => {
            return customers.reduce((sum, item) => {
              const childrenSum = item.children
                ? calculateTotal(item.children)
                : 0;
              return sum + (parseFloat(item.Balance) || 0) + childrenSum;
            }, 0);
          };

          setTotalSum(calculateTotal(rootCustomers));
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });
  }, []);

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const Classiccolumns = [
    {
      title: "Customer Name",
      field: "CustomerName",
      headerFilter: "input",
      defaultVisible: true,
      width: "50%",
    },
    {
      title: "Balance",
      field: "Balance",
      headerFilter: "input",
      bottomCalc: function(values, data, calcParams) {
        // Custom sum: include children balances in group sum
        // If dataTree is used, Tabulator passes only visible rows, so we need to sum recursively
        const sumRecursive = (rows) => {
          let sum = 0;
          rows.forEach(row => {
            sum += Number(row.Balance) || 0;
            if (row.children && Array.isArray(row.children) && row.children.length > 0) {
              sum += sumRecursive(row.children);
            }
          });
          return sum;
        };
        return sumRecursive(data);
      },
      width: "50%",
      defaultVisible: true,

      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `<span style="font-weight:bold;text-decoration:underline;">${CurrencySymbol}0.0</span>`;
        }
        return `<span style="font-weight:bold;text-decoration:underline;">${Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        )}</span>`;
      },

      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `<span style="font-weight:bold;text-decoration:underline;">${CurrencySymbol}0.0</span>`;
        }
        return `<span style="font-weight:bold;text-decoration:underline;">${Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        )}</span>`;
      },

      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `<span style="font-weight:bold;text-decoration:underline;">${CurrencySymbol}0.0</span>`;
        }
        return `<span style="font-weight:bold;text-decoration:underline;">${Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        )}</span>`;
      },

      cellClick: function (e, cell) {
        const rowData = cell.getRow().getData();
        if (rowData?.Customerid) {
          const url = `/customer-balance-detail?custid=${rowData.Customerid}&startdate=${startdate}&enddate=${enddate}&selectedperiod=${selectReport}&agingmethod=${agingMethod}`;
          window.open(url, "_blank");
        }
      },
    },
  ];

  const columns = useMemo(() => [
    {
      header: "Customer Name",
      accessorKey: "CustomerName",
      filterFn: "contains",
    },
    {
      header: "Balance",
      accessorKey: "Balance",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            textAlign: "end",
            alignItems: "center",
            fontWeight: "700",
          }}
          onClick={() =>
            window.open(
              `/customer-balance-detail?custid=${row.original.Customerid}&startdate=${startdate}&enddate=${enddate}&selectedperiod=${selectReport}&agingmethod=${agingMethod}`,
              "_blank"
            )
          }
        >
          {CurrencySymbols(
            Number(row.original.Balance),
            { CurrencySymbol },
            FractionDigits
          )}
        </Box>
      ),
    },
  ]);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Customer Balance Summary Report
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-2">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                  showasofdate={true}
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Aging Method
              </label>
              <div className="row">
                <div className="col-6">
                  <input
                    type="radio"
                    name="day"
                    checked={agingMethod == "Current"}
                    onChange={(e) =>
                      setAgingMethod(
                        e.target.checked ? "Current" : "ReportDate"
                      )
                    }
                  />
                  <label className="col-form-label form-label p-lg-medium ms-2">
                    Current
                  </label>
                </div>
                <div className="col-6">
                  <input
                    type="radio"
                    name="day"
                    checked={agingMethod == "ReportDate"}
                    onChange={(e) =>
                      setAgingMethod(
                        e.target.checked ? "ReportDate" : "Current"
                      )
                    }
                  />
                  <label className="col-form-label form-label p-lg-medium ms-2">
                    Report Date
                  </label>
                </div>
              </div>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <div className="card mt-3">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 className="p">SonarPos</h6>
                    <p className="fw-bold p-regular">
                      Customer Balance Summary
                    </p>
                    <div className="row">
                      <p>
                        {/* Date:{" "} */}
                        {enddate === ""
                          ? "All Data"
                          : "As of " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                        {/* {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )} */}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="">
                  <div className="">
                    <div>
                      {ReportViewPermission == true ? (
                        <button
                          className="btn btn-secondary"
                          onClick={() => setClassicView(!classicView)}
                        >
                          {" "}
                          {classicView ? "Classic View" : "Morden View"}
                        </button>
                      ) : (
                        <></>
                      )}
                      {classicView ? (
                        <CommonTabular
                          Data={responseData}
                          columns={Classiccolumns}
                          Groupvalue={['CustomerName']}
                          Reportname={"Customer Balance Summary"}
                          frozenRowvalue={0}
                          layout={"fitDataFill"}
                          dataTreeStartExpanded={"children"}
                          dataTree={true}
                          Onrefresh={() => apicall()}
                        />
                      ) : (
                        <CommonMatrialReactTable
                          MainHeading="Sonar POS"
                          ReportHeading="Customer Balance Summary"
                          columns={columns}
                          data={responseData}
                          startdate={startdate}
                          enddate={enddate}
                          columnGrouping={[]}
                          columnsVisibility={{}}
                          enableRowSelection={false}
                        />
                      )}
                    </div>
                    <div style={{ textAlign: "right" }} className=" mt-5 ">
                      <p class="text-right p-medium">
                        Total Amount:{" "}
                        {CurrencySymbols(
                          Number(totalSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                        {/* Total Amount: ${Number(totalSum).toFixed(2)} */}
                      </p>
                      <hr
                        style={{
                          display: "inline-block",
                          borderBottom: "3px solid black",
                          width: "30%",
                        }}
                      />
                    </div>
                    <hr />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 text-center"></div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CustomerBalanceSummary;
